import {
  Alert as MUIAlert,
  AlertTitle,
  Box,
  CircularProgress,
  styled,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const Alert = styled(MUIAlert)(({theme}) => ({
  borderRadius: 10,
  '& .MuiAlert-message': {
    ...theme.typography.body1,
  },
}));

export const AlertSnackbar = ({
  progress,
  closeButton = true,
  closeToast,
  title = '',
  message,
  actions,
  severity = 'info',
  ...props
}) => {
  return (
    <Alert
      icon={false}
      elevation={2}
      variant="filled"
      onClose={!progress && closeButton ? closeToast : undefined}
      action={actions}
      severity={severity}
      {...props}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {progress && (
          <CircularProgress color="inherit" size={22} sx={{marginRight: 2}} />
        )}
        {message}
      </Box>
    </Alert>
  );
};

AlertSnackbar.propTypes = {
  actions: PropTypes.array,
  message: PropTypes.node,
  closeToast: PropTypes.func,
  title: PropTypes.string,
  severity: PropTypes.string,
  progress: PropTypes.bool,
  closeButton: PropTypes.bool,
};

export default AlertSnackbar;
